import classNames from 'classnames';
import React from 'react';
import { errorGlowText, primary } from '../../Styles/Colours';
import { IconProps } from '../StyledIcon';
import styles from './StaticNavMenu.module.scss';

type StaticNavMenuItemProps = {
    icon: React.ReactElement<IconProps>;
    title: string;
    disabled?: boolean;
    isNavModal?: boolean;
    replace?: boolean;
    isCollapsed: boolean;
    isActive: boolean;
    errors?: number;
    onClick(): void;
    testId: string;
};

export const StaticNavMenuItem = (props: StaticNavMenuItemProps) => {
    const displayErrors = !!props.errors && props.errors > 0;

    const linkStyles = classNames(styles.link, {
        [styles.linkActive]: props.isActive && !props.disabled,
        [styles.linkDisabled]: props.disabled,
        [styles.linkActiveErrored]: props.isActive && displayErrors,
        [styles.linkErrored]: !props.isActive && displayErrors
    });

    const textClass = classNames(styles.text, {
        [styles.navCollapses]: props.isCollapsed,
        [styles.textDisabled]: props.disabled,
        [styles.textErrored]: displayErrors
    });

    return (
        <div onClick={props.disabled ? undefined : props.onClick} className={linkStyles} data-test-id={props.testId}>
            {React.cloneElement(
                props.icon,
                displayErrors ? { color: errorGlowText } : props.isActive ? { color: primary } : undefined
            )}
            <div className={textClass}>{props.title}</div>
            {displayErrors &&
                (props.isCollapsed ? (
                    <div className={styles.miniBadge} />
                ) : (
                    <div className={styles.errorBadge}>{props.errors}</div>
                ))}
        </div>
    );
};
